import * as actionType from "../constants";
import * as commonData from "../Common";

export const loginDetails = (inputs) => async (dispatch) => {
  dispatch({ type: actionType.LOGIN_DETAILS, payload: inputs });
};
